export const FONT_WEIGHT_BOLD = 700;
export const FONT_WEIGHT_BOLDISH = 600;
export const FONT_WEIGHT_STANDARD = 400;
